import ApiService from '@/api/ApiService'
import proxy from '@/shared/proxy'
import store from '@/store/store'

const LogService = {

  LogError (message: string, metric: any, identifier?: string) {
    return ApiService.postAsyncLog(proxy.Broadcastv1, 'Log',
      {
        OS: 'Web',
        Level: 'Error',
        Message: `${message}`,
        Metrics: metric,
        DeviceId: identifier || this.getLogIdentifier()
      })
  },
  LogErrorJoin (message: string) {
    return ApiService.postAsyncLog(proxy.Broadcastv1, 'Log',
      {
        OS: 'Web',
        Level: 'Error',
        Message: `Join Page error - ${message}`,
        DeviceId: window.location.href
      })
  },
  UncaughtError (message: string) {
    return ApiService.postAsyncLog(proxy.Broadcastv1, 'Log',
      {
        OS: 'Web',
        Level: 'Error',
        Message: `${message}`,
        DeviceId: window.location.href
      })
  },
  LogInformation (message: string, metric: any, identifier?: string) {
    return ApiService.postAsyncLog(proxy.Broadcastv1, 'Log',
      {
        OS: 'Web',
        Level: 'Information',
        message: `${message}`,
        Metrics: metric,
        DeviceId: identifier || this.getLogIdentifier()
      })
  },
  getLogIdentifier () {
    const identifier = store.getIdentifier()
    const bookingId = store.getBookingId()
    return `${identifier?.Identifier}:${identifier?.Token}:${bookingId}`
  }
}
export default LogService
